import React, { FunctionComponent as FC, useState, useContext } from "react";
import { FunnelContext } from "@components/funnel/builder/FunnelContext";

import P from "@atoms/Typography/Text";
import Button from "@components/migratedComponents/molecules/Button";
import Input from "@molecules/Input";

import { useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import { useMutation } from "react-query";
import {
  ImutationParams,
  ISiteParams,
  updateSite,
} from "@components/funnel/hooks/useSiteUpdate";

import SettingCard from "@molecules/SettingCard";

const BusinessInternalId: FC = () => {
  const [editing, setEditing] = useState(false);
  const [updatingInternalId, setUpdatingInternalId] = useState(false);
  const alert = useAlert();
  const { funnelData, updateFrontend } = useContext(FunnelContext);

  const { handleSubmit, register, errors } = useForm({
    mode: "onChange",
  });

  const mutation = useMutation((params: ImutationParams) => updateSite(params));

  const submitSiteUpdates = async (params: ISiteParams) => {
    mutation.mutate(
      {
        id: funnelData.backend.site_attributes.id,
        site_uuid: funnelData.backend.site_attributes.uuid,
        page_id: funnelData.backend.page_attributes.id,
        site: params,
      },
      {
        onSuccess: (responseData) => {
          setEditing(false);
          setUpdatingInternalId(false);
          funnelData.backend = responseData;
          updateFrontend();
          alert.success(<p>Save was successful</p>);
        },
        onError: () => {
          setUpdatingInternalId(false);
          alert.error(
            <>
              <h3>Something went wrong.</h3>
              <p>Please try again later.</p>
            </>
          );
        },
      }
    );
  };

  return (
    <SettingCard
      onClick={() => {
        setEditing(true);
      }}
      onOutsideClick={() => {
        setEditing(false);
      }}
    >
      <P size="3" color="baseDark" fontWeight={600}>
        INTERNAL ID
      </P>
      {editing ? (
        <form onSubmit={handleSubmit(submitSiteUpdates)}>
          <Input
            name="custom_field1"
            register={register()}
            errors={errors.custom_field1}
            defaultValue={funnelData.backend.site_attributes.custom_field1}
          />
          <Button
            color="primary"
            type="submit"
            onClick={() => setUpdatingInternalId(true)}
            leftIcon={updatingInternalId ? "spinner" : null}
          >
            Save
          </Button>
        </form>
      ) : (
        funnelData.backend.site_attributes.custom_field1 && (
          <P size="2" color="baseDarkest" margin="8px 0px 0px 0px">
            {funnelData.backend.site_attributes.custom_field1}
          </P>
        )
      )}
    </SettingCard>
  );
};

export default BusinessInternalId;
